import axios from 'axios'

const api = axios.create({
  baseURL: `${(window as any).__RUNTIME_CONFIG__?.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL}/api/v1`,
})
console.log('Window Runtime Config:', (window as any).__RUNTIME_CONFIG__?.VITE_API_BASE_URL)

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('access_token') || localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response: any) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token error or expired
      localStorage.removeItem('access_token')
      sessionStorage.removeItem('access_token')
      window.location.href = '/auth/login'
    }
    return Promise.reject(error)
  },
)

export default api
